/*********************** Custom JS for Boost AI Search & Discovery  ************************/
boostSDAppConfig.searchSettings.suggestionMobileStyle = 'style2'